<div id="utf-doc-upload-container" class="utf-doc-upload-container">
  <div class="row no-gutters" id="doc-upload-content">
    <div class="col-12">
      <h2 id="doc-upload-heading">
        {{cfetLabels.utf_doc_upload.utf_doc_upload_heading}}
      </h2>
      <p id="doc_upload-subheading">{{cfetLabels.utf_doc_upload.utf_skip_doc_upload_desc}}
      </p>
    </div>
  </div>
  <div class="alert-container">
    <img id="alert_icon" src="assets/images/Frame 1.png" alt="alert desc" />
    <div class="alert-text">
      <strong [innerHTML]="cfetLabels.utf_doc_upload.utf_skip_doc_upload_alert_desc"></strong>
    </div>
  </div>

  <div class="acc-container">
    <div>
      <p id="doc-upload-acc-heading">{{cfetLabels.utf_doc_upload.utf_doc_upload_accheading}}
      </p>
      <div app-abs-accordion role="tablist" id="ac1" class="tiny-accordion" *ngIf="showIDAccordion">
        <app-abs-accordion-group id="eligibilityVerification-EmployeeBadgeAccordian" heading="AT&T advantages"
          [(isOpen)]="OpenEmployeeBadge">
          <div app-abs-head class="accordian-header" id="accordion-header">
            <em abs-expand-collapse-toggle
              [ngClass]="{'icon-accordion-plus':!OpenEmployeeBadge,'icon-accordion-minus':OpenEmployeeBadge}"
              abs-accessibility-click="13,32" aria-label="Toggle Chevron"></em>
            <div class="row accordian-header-title" abs-expand-collapse-toggle abs-accessibility-click="13,32"
              [tabindex]="0">
              <div id="employeeBadge" class="heading-medium">
                <img id="employee" src="assets/images/utf_Emp_Vol_ID.svg" alt="Employee or volunteer ID">
                <h1 style="display:none;">Fix for sonar issues</h1>
                <h2 style="display:none;">Fix for sonar issues</h2>
                <h3 style="display:none;">Fix for sonar issues</h3>
                <h4 class="acc-heading">{{cfetLabels.utf_doc_upload.utf_employee_badge_heading}}</h4>
              </div>
            </div>
          </div>
          <div app-abs-body class="accordion-body" id="accordion-body">
            <div class="row employee-id-desc-column" id="employee-id-desc-column">
              <p *ngIf="agentFacingDesc" id="p_tag" class="p-small">
                {{cfetLabels.utf_doc_upload.utf_employee_badge_desc}}
              </p>
              <p *ngIf="!agentFacingDesc" id="p_tag" class="p-small">
                {{cfetLabels.utf_doc_upload.utf_employee_badge_desc_agent}}</p>
              <div id="id-badge-acc-desc" class="id-badge-acc-desc">
                <p class="p-small" id="p_tag">{{cfetLabels.utf_doc_upload.utf_employee_badge_bullet1_part1}}
                  <strong>{{fname}} </strong>
                  <strong>{{lname}}</strong>{{cfetLabels.utf_doc_upload.utf_employee_badge_bullet1_part2}}
                </p>
              </div>
              <p class="p-small" id="p_tag">{{cfetLabels.utf_doc_upload.utf_employee_badge_bullet4_part1}}
              </p>
              <p class="p-small" id="p_tag">{{cfetLabels.utf_doc_upload.utf_doc_upload_ID_image}}</p>
            </div>
            <div id="employee-badge-image" class="row employee-badge-image">
              <div class="col-md-6">
                <img src="assets/images/Group 901.png" alt="Employee or Volunteer ID Front side Photo"
                  id="emp-front-side">
              </div>
              <div class="col-md-6">
                <img src="assets/images/Group 900.png" alt="Employee or Volunteer ID Back side Photo"
                  id="emp-back-side">
              </div>
            </div>
          </div>
        </app-abs-accordion-group>
      </div>

      <div app-abs-accordion role="tablist" id="ac1" class="tiny-accordion" *ngIf="show101CardAccordion">
        <app-abs-accordion-group id="eligibilityVerification-101CardAccordian" heading="AT&T advantages"
          [(isOpen)]="open101Card">
          <div app-abs-head class="accordian-header" id="accordion-header">
            <em abs-expand-collapse-toggle
              [ngClass]="{'icon-accordion-plus':!open101Card,'icon-accordion-minus':open101Card}"
              abs-accessibility-click="13,32" aria-label="Toggle Chevron"></em>
            <div class="row accordian-header-title" abs-expand-collapse-toggle abs-accessibility-click="13,32"
              [tabindex]="0">
              <div id="civil101Card" class="heading-medium">
                <img id="employee" src="assets/images/utf_Emp_Vol_ID.svg" alt="101 card">
                <h1 style="display:none;">Fix for sonar issues</h1>
                <h2 style="display:none;">Fix for sonar issues</h2>
                <h3 style="display:none;">Fix for sonar issues</h3>
                <h4 class="acc-heading">{{cfetLabels.utf_doc_upload.utf_civil_101_card_heading}}</h4>
              </div>
            </div>
          </div>
          <div app-abs-body class="accordion-body" id="accordion-body">
            <div class="row civil-101card-desc-column" id="civil-101card-desc-column">
              <p id="p_tag" class="p-small">
                {{cfetLabels.utf_doc_upload.utf_civil_101_card_desc}}
              </p>
              <div id="id-badge-acc-desc" class="id-badge-acc-desc">
                <p class="p-small" id="p_tag">{{cfetLabels.utf_doc_upload.utf_civil_101_card_desc_bullet1_part1}}
                  <strong>{{fname}} </strong>
                  <strong>{{lname}}</strong>{{cfetLabels.utf_doc_upload.utf_civil_101_card_desc_bullet1_part2}}
                </p>
              </div>
              <p class="p-small" id="p_tag">{{cfetLabels.utf_doc_upload.utf_civil_101_card_desc_bullet2}}</p>
            </div>
            <div id="civil-101-card-image" class="row civil-101-card-image">
              <div class="col-md-6" id="civil-101-card-image">
                <img src="assets/images/101 Card.svg" alt="101 card Front and Back side photo" id="civil101CardImage"
                 >
              </div>
            </div>
          </div>
        </app-abs-accordion-group>
      </div>
      
      <div app-abs-accordion role="tablist" id="ac2" class="tiny-accordion" *ngIf="showPayAccordion">
        <app-abs-accordion-group id="eligibilityVerification-EmployeePayAccordian" heading="AT&T advantages"
          [(isOpen)]="OpenEmployeePay">
          <div app-abs-head class="accordian-header">
            <em abs-expand-collapse-toggle
              [ngClass]="{'icon-accordion-plus':!OpenEmployeePay,'icon-accordion-minus':OpenEmployeePay}"
              abs-accessibility-click="13,32" aria-label="Toggle Chevron"></em>
            <div class="row accordian-header-title" abs-expand-collapse-toggle abs-accessibility-click="13,32"
              [tabindex]="0">
              <div id="employeePay" class="heading-medium">
                <img id="employeestub" src="assets/images/utf_Emp_Paystub.svg" alt="Employee paystub">
                <h1 style="display:none;">Fix for sonar issues</h1>
                <h2 style="display:none;">Fix for sonar issues</h2>
                <h3 style="display:none;">Fix for sonar issues</h3>
                <h4 class="acc-heading">{{cfetLabels.utf_doc_upload.utf_employee_pay_stub_heading}}</h4>
              </div>
            </div>
          </div>
          <div app-abs-body class="accordion-body" id="accordion-body">
            <div class="row pay-stub-desc-column" id="pay-stub-desc-column">
              <p *ngIf="!agentFacingDesc" class="p-small">{{cfetLabels.utf_doc_upload.utf_employee_pay_stub_desc}}</p>
              <p *ngIf="agentFacingDesc" class="p-small">
                {{cfetLabels.utf_doc_upload.utf_employee_pay_stub_desc_agent}}
              </p>
            </div>
            <div *ngIf="userFacing">
              <div id="pay-stub-acc-desc" class="row pay-stub-acc-desc">
                <p class="p-small">{{cfetLabels.utf_doc_upload.utf_employee_pay_stub_bullet1}}</p>
              </div>
              <p class="p-small">{{cfetLabels.utf_doc_upload.utf_employee_pay_stub_bullet2_part1}}
                <strong>{{fname}} </strong>
                <strong>{{lname}}</strong>{{cfetLabels.utf_doc_upload.utf_employee_pay_stub_bullet2_part2}}
              </p>
              <p class="p-small">{{cfetLabels.utf_doc_upload.utf_employee_pay_stub_bullet3_part1}}
                <strong>{{workDept}}</strong>{{cfetLabels.utf_doc_upload.utf_employee_pay_stub_bullet3_part2}}
              </p>
              <p class="p-small">{{cfetLabels.utf_doc_upload.utf_employee_pay_stub_bullet8}}</p>
            </div>
            <div id="employee-stub-image" class="row employee-stub-image">
              <img src="assets/images/Pay Stub.png" alt="Employee Pay Stub" id="Employee-pay-stub">
            </div>
          </div>
        </app-abs-accordion-group>
      </div>
      <div app-abs-accordion role="tablist" id="ac3" class="tiny-accordion" *ngIf="showCertAccordion">
        <app-abs-accordion-group id="eligibilityVerification-CertificationAccordian" heading="AT&T advantages"
          [(isOpen)]="OpenCertification">
          <div app-abs-head class="accordian-header">
            <em abs-expand-collapse-toggle
              [ngClass]="{'icon-accordion-plus':!OpenCertification,'icon-accordion-minus':OpenCertification}"
              abs-accessibility-click="13,32" aria-label="Toggle Chevron"></em>
            <div class="row accordian-header-title" abs-expand-collapse-toggle abs-accessibility-click="13,32"
              [tabindex]="0">
              <div id="certification" class="heading-medium">
                <img id="check_certification" src="assets/images/verified_32.png" alt="Certification">
                <h1 style="display:none;">Fix for sonar issues</h1>
                <h2 style="display:none;">Fix for sonar issues</h2>
                <h3 style="display:none;">Fix for sonar issues</h3>
                <h4 class="acc-heading" id="heading">{{cfetLabels.utf_doc_upload.utf_certification_heading}}</h4>
              </div>
            </div>
          </div>
          <div app-abs-body class="accordion-body" id="accordion-body">
            <div class="row certification-desc-column" id="certification-desc-column">
              <p *ngIf="!agentFacingDesc" class="p-small">{{cfetLabels.utf_doc_upload.utf_certification_desc}}</p>
              <p *ngIf="agentFacingDesc" class="p-small">{{cfetLabels.utf_doc_upload.utf_certification_desc_agent}}
              </p>
            </div>
            <div *ngIf="userFacing">
              <div id="certification-desc" class="certification-desc">
                <p class="p-small">{{cfetLabels.utf_doc_upload.utf_certification_bullet4}}</p>
                <ul id="certification_bullets">
                  <li class="extra-space">{{cfetLabels.utf_doc_upload.utf_certification_bullet4_part1}}</li>
                  <li class="extra-space">{{cfetLabels.utf_doc_upload.utf_certification_bullet4_part2}}</li>
                  <li class="extra-space">{{cfetLabels.utf_doc_upload.utf_certification_bullet4_part3}}</li>
                  <li class="extra-space">{{cfetLabels.utf_doc_upload.utf_certification_bullet4_part4}}</li>
                  <li class="extra-space">{{cfetLabels.utf_doc_upload.utf_certification_bullet4_part5}}</li>
                  <li class="extra-space">{{cfetLabels.utf_doc_upload.utf_certification_bullet4_part6}}</li>
                </ul>
              </div>
            </div>
            <p class="p-small">{{cfetLabels.utf_doc_upload.utf_certification_bullet5}} <strong>{{fname}} {{lname}}</strong></p>
            <div id="certification-image" class="row certification-image">
              <img src="assets/images/certification.png" alt="Certification" id="certification_img">
            </div>
          </div>
        </app-abs-accordion-group>
      </div>
      <div app-abs-accordion role="tablist" id="ac4" class="tiny-accordion" *ngIf="showSignedAccordion">
        <app-abs-accordion-group id="eligibilityVerification-SignedLetterAccordian" heading="AT&T advantages"
          [(isOpen)]="OpenSignedLetter">
          <div app-abs-head class="accordian-header">
            <em abs-expand-collapse-toggle
              [ngClass]="{'icon-accordion-plus':!OpenSignedLetter,'icon-accordion-minus':OpenSignedLetter}"
              abs-accessibility-click="13,32" aria-label="Toggle Chevron"></em>
            <div class="row accordian-header-title" abs-expand-collapse-toggle abs-accessibility-click="13,32"
              [tabindex]="0">
              <div id="signedLetter" class="heading-medium">
                <img id="signed_proof" src="assets/images/pencil_32.png" alt="Signed Letter">
                <h1 style="display:none;">Fix for sonar issues</h1>
                <h2 style="display:none;">Fix for sonar issues</h2>
                <h3 style="display:none;">Fix for sonar issues</h3>
                <h4 class="acc-heading" id="heading">{{cfetLabels.utf_doc_upload.utf_signed_letter_heading}}</h4>
              </div>
            </div>
          </div>
          <div app-abs-body class="accordion-body" id="accordion-body">
            <div class="row signed-letter-desc-column" id="signed-letter-desc-column">
              <p *ngIf="!agentFacingDesc" class="p-small">{{cfetLabels.utf_doc_upload.utf_signed_letter_desc}}</p>
              <p *ngIf="agentFacingDesc" class="p-small">{{cfetLabels.utf_doc_upload.utf_signed_letter_desc_agent}}
              </p>
            </div>
            <div *ngIf="userFacing">
              <div id="signed-letter-desc" class="row signed-letter-desc">
                <p class="p-small">{{cfetLabels.utf_doc_upload.utf_signed_letter_bullet5}} <strong>{{entity}}</strong> </p>
              </div>
            </div>
            <p class="p-small">{{cfetLabels.utf_doc_upload.utf_signed_letter_bullet10}} <strong>{{fname}} {{lname}}</strong> </p>
            <p class="p-small">{{cfetLabels.utf_doc_upload.utf_signed_letter_bullet11}} <strong>{{workDept}}</strong> {{cfetLabels.utf_doc_upload.utf_signed_letter_bullet12}}</p>
            <p class="p-small">{{cfetLabels.utf_doc_upload.utf_signed_letter_bullet13}}</p>
            <p class="p-small">{{cfetLabels.utf_doc_upload.utf_signed_letter_bullet14}}</p>
            <div id="signed-letter-image" class="row signed-letter-image">
              <img src="assets/images/Signed Letter.png" alt="Signed Letter" id="signed_img">
            </div>
          </div>
        </app-abs-accordion-group>
      </div>
    </div>
  </div>

  <div class="row no-gutters" id="doc-upload-footer-warning-column">
    <div class="col-12 footer-content" [ngClass]="{'file-upload-height': !showCertAccordion}">
      <div class="footer-txt">
        <p>{{cfetLabels.cfet_doc_upload.file_desc}}</p>
        <p>{{cfetLabels.cfet_doc_upload.file_desc1}}</p>
        <p>{{cfetLabels.cfet_doc_upload.file_desc2}}</p>
        <p>{{cfetLabels.utf_doc_upload.utf_warning_text}}</p>
      </div>
    </div>
  </div>
  <hr />
  <div class="col-12 btn-container" id="doc-upload-submit-footer-buttons">
    <button type="button" id="done-btn" (click)="done($event)" (keyup)="done($event)" tabindex="0"
      aria-label="Done button" class="btn btn-alt btn-medium"
      *ngIf="showDoneButton">{{cfetButtonLabels.button_labels.continue}}
    </button>
    <button type="button" id="skip_button" (click)="skipUpload($event)" (keyup)="skipUpload($event)"
      class="btn btn-alt btn-medium" tabindex="0" *ngIf="!disableSkipButton" [disabled]="disableSkipButton">
      {{cfetButtonLabels.button_labels.utf_skip}}
    </button>
    <div class="right-buttons">
      <div id="cancel">
        <a data-dismiss="modal" (click)="cancelCreation($event)" (keyup)="cancelCreation($event)" tabindex="0"
          type="button">
          {{cfetButtonLabels.button_labels.cancel}}</a>
      </div>
      <div class="row no-gutters" id="doc-upload-footer-column">
        <div class="col-12" *ngIf="showUploadButton">
          <button type="button" id="upload-btn" (click)="fileInput.click() ; removeError()" tabindex="0"
            [ngClass]="fileUploaded ? 'confirm-color-change' : 'btn btn-alt btn-medium upload-btn'">
            <span *ngIf="fileUpload">

              {{cfetButtonLabels.button_labels.utf_upload}}
            </span>
            <span *ngIf="fileUploaded" id="upload_another">
              <img class="photos" src="assets/images/utf-gallery-upload.svg" alt="Photos">
              {{cfetButtonLabels.button_labels.utf_uploadAnother}}</span>
          </button>
          <label for="file-upload" style="display:none;">File Upload Sonar Fix</label>
          <input #fileInput #attachments type="file" name="file-upload" id="file-upload" style="display:none;"
            (change)="onFileChange($event)" />
        </div>
      </div>
      <div class="row no-gutters" id="uploaded-file-section" *ngIf="fileList.length > 0">
        <div class="col-md-12">
          <div class="uploaded-result-column" id="uploaded-result-column"
            *ngFor="let file of fileList; let $index=index;">
            <div id="file-format-input" class="row no-gutters file-format-input">
              <div class="col-1 uploaded-doc-image"> <img [src]=[file.imageurl] alt="" id="img_upload">
              </div>
              <div class="col-10">
                <p class="uploaded-document-name" id="uploaded-document-name">{{file.file.name}} </p>
              </div>
              <div class="col-1" id="iconClose" (click)="removeSelectedFile($index, $event, file.file.name)"
                (keyup.enter)="removeSelectedFile($index, $event, file.file.name)" tabindex="0">
                <img src="assets/images/trash_16.png" alt="Delete File">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div [ngClass]="(deleteModalClicked === true) ? 'delete-modal' : ''">
    <app-file-confirmation-delete-modal-utf [openModal]="openFileDeleteModal"
      (modalCloseEvent)="closeDeleteFileModal($event)" [selectedFile]="selectedFile">
    </app-file-confirmation-delete-modal-utf>
  </div>
  <div [ngClass]="(skipModalClicked === true) ? 'skip-utf-modal' : ''">
    <app-skip-for-now-modal-utf [openModal]="openSkipFileUploadModal"
      (modalCloseEvent)="closeSkipFileUploadModal($event)">
    </app-skip-for-now-modal-utf>
  </div>
  <div [ngClass]="showCancelModal ? 'cancel-modal-1' : ''">
    <app-cancel-modal-utf [openModal]="openCancelModal" (closeModal)="closeModal($event)">
    </app-cancel-modal-utf>
  </div>
</div>